// noinspection JSUnusedGlobalSymbols,ES6UnusedImports

import {Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortable} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IFrotaModel} from 'src/app/frota/model/frota.model';
import {LoginModel} from 'src/app/model/login.model';
import {AuthenticationService} from 'src/app/services/authentication.service';
import {SnackBarService} from 'src/app/services/snack-bar-service.service';
import {SubfrotaService} from '../subfrota.service';
import {IRelatorioExtratoCartao, RelatorioExtratoCartao} from "../model/relatorio-extrato-cartao";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NomeCombustivel} from 'src/app/precos-combustiveis/model/AlteracaoCombustivel';
import {AbastecimentosViewModel} from '../model/abastecimentos-view-model';
import {FiltroAbastecimentosViewModel} from '../model/filtro-abastecimentos-view-model';

@Component({
  selector: 'app-subfrota-relatorio-abastecimentos-alterados',
  templateUrl: './subfrota-relatorio-abastecimentos-alterados.component.html',
  styleUrls: ['./subfrota-relatorio-abastecimentos-alterados.component.scss']
})
export class SubfrotaRelatorioAbastecimentosAlteradosComponent implements OnInit {

  filtroForm: FormGroup;
  listaCombustiveis: NomeCombustivel[] = [];
  usuario !: LoginModel | undefined;
  isCollapsed!: boolean;
  displayedColumns!: string[];
  public dataSource!: MatTableDataSource<AbastecimentosViewModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = 0;

  constructor(
    private fb: FormBuilder,
    private subFrotaService: SubfrotaService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private renderer: Renderer2) {

    this.usuario = this.subFrotaService?.usuario;

    // Inicialização do Filtro e das colunas do Material Table que precisam ficar no Constructor
    this.displayedColumns = ['flgEditavel', 'nomFantasiaPosto', 'dscPlaca', 'datAbastecimento', 'indCombustivel', 'qtdVolume', 'vlrUnitario', 'vlrTotal', 'numKm',];


    this.filtroForm = this.fb.group({
      dscPlaca: ['', Validators.maxLength(7)],
      indCombustivel: [''],
      datIniAbastecimento: ['', [this.DataNaoFutura]],
      datFimAbastecimento: ['', [this.DataNaoFutura, this.DataFinalNaoAteriorInicial]],
    })

  }

  ngOnInit(): void {

    // Liga a animação de Loading (Spinner) na tela
    this.loading++;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {
          this.iniciar();
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });


  }

  private async iniciar() {
    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? "PADRAO");
    this.getTiposCombustiveis();
    this.buscarDadosAbastecimentos()

  }

  private DataNaoFutura(control: FormControl) {
    const data = new Date(control.value);
    const dataAtual = new Date();

    if (isNaN(dataAtual.getTime()))
      return null;

    if (data > dataAtual) {
      return {invalidDateRange: true}
    }
    return null;
  }

  private DataFinalNaoAteriorInicial(control: FormControl) {
    const dataInicio = new Date(control.root.get('datIniAbastecimento')?.value);
    const dataFim = new Date(control.value);

    if (isNaN(dataInicio.getTime()) && isNaN(dataFim.getTime()))
      return null;


    if (isNaN(dataInicio.getTime()) || dataFim < dataInicio) {
      return {invalidDataFim: true}
    }
    return null;
  }

  filtrarRelatorio() {
  }

  public filtrarDados() {
    this.buscarDadosAbastecimentos()
  }

  async getTiposCombustiveis() {

    await this.subFrotaService.getListaCombustiveis(this.subFrotaService?.usuario?.retorno?.guid)
      //await this.subFrotaService.getListaCombustiveis(this.guidTemp)
      .subscribe(ret => {
        if (!ret.sucesso) {
          console.log("Erro no retorno da api: " + ret.mensagens)
        } else {
          this.listaCombustiveis = ret.retorno.filter((x: {
            descricaoCombustivel: string;
          }) => x.descricaoCombustivel != '')
          this.listaCombustiveis = this.listaCombustiveis.sort((a, b) => a.codigoCombustivel - b.codigoCombustivel);
        }
      })

  }

  private async buscarDadosAbastecimentos() {

    this.loading++;

    const filtro: FiltroAbastecimentosViewModel = {
      guid: this.subFrotaService?.usuario?.retorno?.guid,
      //guid: this.guidTemp,
      rowsppage: 100,
    };

    if (this.filtroForm.get('dscPlaca')?.value != '')
      filtro.dscPlaca = this.filtroForm.get('dscPlaca')?.value;

    if (this.filtroForm.get('indCombustivel')?.value != '')
      filtro.indCombustivel = this.filtroForm.get('indCombustivel')?.value;

    if (this.filtroForm.get('datIniAbastecimento')?.value != '')
      filtro.datIniAbastecimento = this.filtroForm.get('datIniAbastecimento')?.value;

    if (this.filtroForm.get('datFimAbastecimento')?.value != '')
      filtro.datFimAbastecimento = this.filtroForm.get('datFimAbastecimento')?.value;


    this.subFrotaService.obterListaAbastecimentosEditadosDaFrota(filtro).subscribe(ret => {
      if (ret.sucesso) {

        console.log(ret.retorno)
        this.dataSource = new MatTableDataSource<AbastecimentosViewModel>(ret.retorno);
        console.log(this.dataSource.data)
        this.dataSource.paginator = this.paginator;
        this.sort.sort(({id: 'codigoAbastecimento', start: 'desc'}) as MatSortable);
        this.dataSource.sort = this.sort;
        this.sort.sort(({id: 'codigoAbastecimento', start: 'asc'}) as MatSortable);
        this.sort.disableClear = true;
        this.dataSource.sort = this.sort;


      } else {
        const msgs = ret.mensagens.join("\n");
        this.snackBar.flashMessage(msgs, ['snackbar-error'], 'Fechar', 0);
      }
    })

    this.loading--;
  }

  mostrarNomeCombustivel(indCombustivel: string) {
    const comb = this.listaCombustiveis.find(x => x.descricaoCombustivel.trim().toUpperCase() === indCombustivel.trim().toUpperCase());
    return comb?.combustivel == undefined ? '' : comb.combustivel;
  }
}
